import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { MainTimesheet } from "../../class/main-timesheet";

@Injectable({
  providedIn: "root",
})
export class VerifyTimesheetService {
  constructor(private http: HttpClient) {}

  //get data for data table
  fetchMainTimesheetList(): Observable<any> {
    return this.http.get<any>(`${environment.url}/apiMainTimeSheet/getAll`);
  }

  //update status
  updateMainTimesheet(maintimesheet: MainTimesheet): Observable<any> {
    return this.http.put<any>(
      `${environment.url}/apiMainTimeSheet/upMainTimesheet`,
      maintimesheet
    );
  }

  //get data for drop down filter employee column
  getEmployeeMainTimesheetList(): Observable<any> {
    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/findEmployeeMainTimesheet`
    );
  }

  //get data with filter with paging
  getMainTimesheetByFilterWithPaging(
    keyword: string,
    tab: string,
    leadId: number,
    pageNo: number,
    pageSize: number,
    sortBy: string,
    isAscending: boolean,
    MonthSearch: string,
    YearSearch: string
  ): Observable<any> {
    let params = new HttpParams();
    if (keyword != null) {
      params = params.append("keyword", keyword);
    }
    if (tab != null) {
      params = params.append("tab", tab);
    }
    if (leadId != null) {
      params = params.append("leadId", leadId);
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (sortBy != null) {
      params = params.append("sortBy", sortBy);
    }
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (MonthSearch != null) {
      params = params.append("MonthSearch", MonthSearch);
    }
    if (YearSearch != null) {
      params = params.append("YearSearch", YearSearch);
    }

    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/getAllMainTimesheetFilterPaging`,
      { params: params }
    );
  }

  getMainTimesheetByFilterWithPagingByUnderManager(
    keyword: string,
    tab: string,
    leadIdList: any[],
    pageNo: number,
    pageSize: number,
    sortBy: string,
    isAscending: boolean,
    MonthSearch: string,
    YearSearch: string,
    managerId: number
  ): Observable<any> {
    console.log("name before sent api : ", keyword);

    let params = new HttpParams();
    if (tab != null) {
      params = params.append("tab", tab);
    }
    if (leadIdList != null) {
      params = params.append("leadIdList", leadIdList.join(","));
    }
    if (pageNo != null) {
      params = params.append("pageNo", pageNo);
    }
    if (pageSize != null) {
      params = params.append("pageSize", pageSize);
    }
    if (sortBy != null) {
      params = params.append("sortBy", sortBy);
    }
    if (isAscending != null) {
      params = params.append("isAscending", isAscending);
    }
    if (keyword != null) {
      params = params.append("keyword", keyword);
      console.log("params when append keyword", params);
    }
    if (MonthSearch != null) {
      params = params.append("MonthSearch", MonthSearch);
    }
    if (YearSearch != null) {
      params = params.append("YearSearch", YearSearch);
    }
    if (managerId != null) {
      params = params.append("managerId", managerId);
    }

    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/getAllMainTimesheetFilterPagingByUnderManager`,
      { params: params }
    );
  }

  public getMainTimesheetByFilter(
    month: any,
    year: any,
    fullName: string,
    status: string
  ): Observable<any> {
    let params = new HttpParams();
    if (month != null) {
      params = params.append("month", month);
    }
    if (year != null) {
      params = params.append("year", year);
    }

    if (fullName != null) {
      params = params.append("fullName", fullName);
    }

    if (status != null) {
      params = params.append("status", status);
    }

    return this.http.get<any>(
      `${environment.url}/apiMainTimeSheet/getMainTimesheetByFilter`,
      { params: params }
    );
  }

  public checkMandayTimesheet(mainTimesheetId: number) {
    let params = new HttpParams();
    if (mainTimesheetId != null) {
      params = params.append("mainTimesheetId", mainTimesheetId);
    }
    return this.http.get<any>(
      `${environment.url}/apiTimesheet/checkManday`,
      { params: params }
    );
  }

  getAvailableDates(): Observable<{ years: number[]; months: number[] }> {
    return this.http.get<{ years: number[]; months: number[] }>(
      `${environment.url}/apiTimesheet/available-dates`
    );
  }

  getMonthsForYear(year: number): Observable<number[]> {
    return this.http.get<number[]>(
      `${environment.url}/apiTimesheet/months/${year}`
    );
  }

  getYearsForMonth(month: number): Observable<number[]> {
    return this.http.get<number[]>(
      `${environment.url}/apiTimesheet/years/${month}`
    );
  }
}
